import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import LaunchIcon from '@mui/icons-material/Launch';

export default function UserDashboardItem({ item, deleteItem, updateMode ,index}: any) {


    const openNewTab=()=>{

        window.open(item.url)
    }
    return (

        <>
            <div style={{ backgroundColor: "white", height: "35px", marginLeft: "-1px", marginRight: "-1px", borderRight: updateMode == true ? "2px dashed #C1C7CB" : "2px solid #C1C7CB", borderLeft: updateMode == true ? "2px dashed #C1C7CB" : "2px solid #C1C7CB", borderTop: updateMode == true ? "2px dashed #C1C7CB" : "2px solid #C1C7CB", borderRadius: "2px" }}>


                <div style={{ color: "#9AAFC4", margin: "5px", float: "left" }}
                >

                    <LaunchIcon
                        style={{ width: "24px", height: "24px", color: "#9AAFC4" }}
                        onClick={() => openNewTab()}
                    />
                    {deleteItem == null ? <></> :
                        <>
                            <DragIndicatorIcon
                                style={{ width: "24px", height: "24px", color: "#9AAFC4" }}
                                //onClick={() => dragItem(item)}
                            />
                            <ClearIcon
                                style={{ width: "24px", height: "24px", color: "#9AAFC4" }}
                                onClick={() => deleteItem(item,index)}
                            />
                        </>
                    }
                </div>

                <div
                    className="iranSansMedium" style={{ marginRight: "5px", marginTop: "8px", marginBottom: "5px", float: "right", fontSize: "12px", color: "#273C51" }}>
                    {item.title}
                </div>
            </div>

            <iframe
                src={item.url}
                style={{
                    overflow: "hidden",
                    //pointerEvents: "none",
                    backgroundColor: "#fff",
                    display: "block",
                    position: "absolute",
                    height: " -webkit-calc(100% - 30px)",
                    width: "100%",
                    borderRight: updateMode == true ? "2px dashed #C1C7CB" : "1px solid #C1C7CB",
                    borderLeft: updateMode == true ? "2px dashed #C1C7CB" : "1px solid #C1C7CB",
                    borderBottom: updateMode == true ? "2px dashed #C1C7CB" : "1px solid #C1C7CB",
                    borderTop:"0px",
                    margin:"0px",
                    padding:"0"
                }}
            />
        </>
    )
}
